<template>
    <div class="tw:w-full tw:mx-auto tw:px-4 tw:pb-10">
        <breadcrumb-page :title="title" :list_breadcrumb="listBreadcrumb" />

        <div class="tw:flex tw:flex-col tw:sm:flex-row tw:sm:items-center tw:sm:justify-end tw:gap-4 tw:pb-4">
            <slot name="header"></slot>
        </div>

        <!-- tw:bg-white tw:rounded-3xl tw:border tw:border-slate-200/80 tw:shadow-xl tw:shadow-slate-200/50  -->
        <div
            :class="`tw:bg-white tw:rounded-3xl tw:border tw:border-slate-200/80 tw:shadow-xl tw:shadow-slate-200/50 tw:overflow-hidden tw:transition-all ${classBody}`">
            <slot name="body"></slot>
        </div>

        <slot name="footer"></slot>
    </div>
</template>

<script>
export default {
    name: 'BasePage',
    props: {
        title: {
            type: String,
            default: ''
        },
        classBody: {
            type: String,
            default: ''
        },
        listBreadcrumb: {
            type: Array,
            default: () => []
        }
    }
}
</script>